<template>
  <div class="manual app-container">
    <div class="global-header-wrap">
      <h3>用户手册</h3>
      <div class="manual-header-right">
        <button
          class="global-button-style"
          @click="
            $router.push({ name: 'createManual', query: { ...$route.query } })
          "
        >
          新增
        </button>
      </div>
    </div>
    <div class="manual-main">
      <el-card class="manual-main-left" :body-style="{ padding: '0px' }">
        <div slot="header">
          <div class="manual-header">
            <span>类别</span>
            <button class="global-button-style" @click="createCategory">
              新增分类
            </button>
          </div>
        </div>
        <div class="manual-menu">
          <div style="flex:1;" v-bar>
            <div>
              <el-menu
                :default-active="$route.query.model"
                @select="selectMenu"
              >
                <el-submenu
                  class="manual-menu-submenu"
                  v-for="(item, index) in category"
                  :index="item._id"
                  :key="item._id"
                >
                  <template slot="title">
                    <p class="omitText">{{ item.name }}</p>
                    <div class="manual-menu-submenu-btn">
                      <i
                        class="el-icon-edit"
                        @click.stop="updateCategory(item)"
                      ></i>
                      <i
                        class="el-icon-delete"
                        @click.stop="delCategory(item, index)"
                      ></i>
                    </div>
                  </template>
                  <el-menu-item
                    class="manual-menu-item"
                    :class="{
                      menuActive: data.model === $route.query.model
                    }"
                    v-for="data in item.models"
                    :index="data.model"
                    :key="data.model"
                  >
                    <p class="omitText">{{ data.model }}</p>
                  </el-menu-item>
                </el-submenu>
              </el-menu>
            </div>
          </div>
        </div>
      </el-card>
      <el-card class="app-table-container" :body-style="{ padding: '20px' }">
        <div class="global-body-wrap">
          <appTable
            :tableData="tableData"
            :tableProps="tableProps"
            :selectCtrl="false"
            @tableHandle="tableHandle"
          />
        </div>
        <pagination
          :pageSize="params.limit"
          :total="total"
          @pageNum="getPageNum"
        />
      </el-card>
    </div>
    <el-dialog
      title="手册详情"
      :visible.sync="centerDialogVisible"
      width="50%"
      center
    >
      <div v-if="manualItem">
        <div class="manual-dialog-item">
          <p>标题</p>
          <p>{{ manualItem.title }}</p>
        </div>
        <div class="manual-dialog-item">
          <p>语言</p>
          <p>{{ manualItem.langs.join("、") }}</p>
        </div>
        <div class="manual-dialog-item">
          <p>PDF标题</p>
          <p>{{ manualItem.file.name }}</p>
        </div>
        <div class="manual-dialog-item">
          <p>PDF链接</p>
          <p>{{ manualItem.file.url }}</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="centerDialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <transition name="fade">
      <DelPopup @deleteHandle="deleteHandle" v-if="delPopup" />
    </transition>

    <el-dialog :title="title" :visible.sync="addPopup" width="600">
      <div class="manualHandle-dialog" v-bar>
        <el-form
          :model="ruleForm"
          ref="form"
          label-position="top"
          :rules="rules"
          label-width="80px"
          :inline="false"
          size="mini"
        >
          <el-form-item label="标签名称">
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>

          <template v-for="(item, index) in ruleForm.models">
            <el-form-item :key="index">
              <div class="manualHandle-dialog-item">
                <div class="manualHandle-dialog-item-left">
                  <p v-if="index === 0">型号：</p>
                  <el-input v-model="item.model"></el-input>
                </div>
                <div class="manualHandle-dialog-item-right">
                  <p v-if="index === 0">是否定制：</p>
                  <el-radio-group v-model="item.customModel">
                    <el-radio label="no">否</el-radio>
                    <el-radio label="yes">是</el-radio>
                  </el-radio-group>
                </div>
                <div class="manualHandle-dialog-item-btn">
                  <i
                    class="el-icon-minus"
                    @click="delCategoryItem(item, index)"
                  ></i>
                  <i
                    class="el-icon-plus"
                    @click="addCategoryItem"
                    v-if="ruleForm.models.length - 1 === index"
                  ></i>
                </div>
              </div>
            </el-form-item>
          </template>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="addPopup = false">取消</el-button>
        <el-button type="primary" @click="categoryHandle">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import appTable from "./components/appTable";
import pagination from "@/components/pagination";
import DelPopup from "@/components/delPopup";
// import AddTagPopup from "./components/addTagPopup";
export default {
  components: {
    appTable,
    pagination,
    // AddTagPopup,
    DelPopup
  },
  computed: {
    ...mapGetters(["delPopup"]),
    rules() {
      let rules = {
        name: [
          { required: true, message: this.$t("verify.tag"), trigger: "blur" }
        ]
        // models: [
        //   { required: true, message: this.$t("verify.tag"), trigger: "blur" }
        // ]
      };
      return rules;
    },
    tableProps() {
      let tableProps = [
        {
          prop: "title",
          label: this.$t("devices.power.title")
        },
        {
          prop: "langs",
          label: "语言"
        },
        {
          prop: "file.name",
          label: "PDF标题",
          obj: true
        },
        {
          prop: "updatedAt",
          label: "创建时间"
        },
        {
          prop: "handle",
          label: this.$t("commonMsg.handle"),
          width: 220,
          btn: [
            this.$t("commonMsg.edit"),
            this.$t("commonMsg.checkDetails"),
            this.$t("commonMsg.del")
          ]
        }
      ];
      return tableProps;
    },
    ruleProps() {
      let ruleProps = [
        {
          prop: "name",
          label: this.$t("org.tagName"),
          placeholder: this.$t("placeholder.tagName")
        },
        {
          prop: "models",
          label: "设备型号(多种型号用\\隔开)",
          placeholder: "请输入设备型号"
        }
      ];
      return ruleProps;
    }
  },
  data() {
    return {
      params: {
        limit: 20,
        page: 1,
        type: "manual",
        sortBy: "updatedAt"
      },
      category: [],
      tableData: [],
      total: 0,
      title: "",
      manualItem: null,
      centerDialogVisible: false,
      categoryItem: null,
      categoryIdx: 0,
      ruleForm: {
        name: "",
        models: [{ model: "", customModel: "no" }]
      },
      operationType: "",
      addPopup: false
    };
  },
  methods: {
    getCategory() {
      return new Promise(async (resolve, reject) => {
        try {
          let res = await this.$http.getManualGroups({
            limit: 10000,
            page: 1
          });
          this.category = res.data.results;
          if (!this.category.length) return;
          if (this.$route.query.model) {
            this.params.model = this.$route.query.model;
          } else {
            this.params.model = this.category[0].models[0].model;
            this.$router.push({
              path: this.$route.fullPath,
              query: { model: this.category[0].models[0].model }
            });
          }
          this.getList();
          resolve("ok");
        } catch (error) {
          reject(error);
        }
      });
    },

    delCategoryItem(item, index) {
      this.ruleForm.models.splice(index, 1);
    },
    addCategoryItem() {
      this.ruleForm.models.push({ model: "", customModel: "no" });
    },

    async categoryHandle() {
      try {
        if (this.title === "新增分类") {
          await this.$http.createManualGroups(this.ruleForm);
          this.elMsg(this.$t("alertMsg.addSuccess"), "success");
        } else {
          await this.$http.updateManualGroups(
            this.categoryItem._id,
            this.ruleForm
          );
          this.elMsg(this.$t("alertMsg.editSuccess"), "success");
        }
        this.getCategory();
        this.addPopup = false;
      } catch (error) {}
    },

    async createCategory() {
      this.ruleForm = {
        name: "",
        models: [{ model: "", customModel: "no" }]
      };
      this.title = "新增分类";
      this.addPopup = true;
    },

    async updateCategory(item) {
      this.categoryItem = item;
      this.ruleForm = Object.assign({}, item);
      this.title = "更新分类";
      this.addPopup = true;
    },

    async delCategory(item, idx) {
      this.categoryItem = item;
      this.categoryIdx = idx;
      this.operationType = "category";
      this.$store.commit("windowHandle", "delPopup");
    },

    async delModelGroups() {
      await this.$http.delModelGroups(this.categoryItem._id);
      this.category.splice(this.categoryIdx, 1);
      this.elMsg(this.$t("alertMsg.delSuccess"), "success");
      if (this.categoryIdx === 0) {
        this.params.model = this.category[0].models[0];
        this.$router.push({
          path: this.$route.fullPath,
          query: { model: this.category[0].models[0] }
        });
        this.getList();
      }
    },

    async deleteHandle() {
      if (this.operationType === "manual") {
        this.del();
      } else {
        this.delModelGroups();
      }
    },

    selectMenu(model) {
      this.params.model = model;
      this.$router.push({ path: this.$route.fullPath, query: { model } });
      this.getList();
    },

    getList() {
      this.$http.getCloudFiles(this.params).then(res => {
        this.tableData = res.data.results;
        this.total = res.data.count;
      });
    },

    del() {
      this.$http.delCloudFiles(this.manualItem._id).then(res => {
        this.getList();
        this.elMsg(this.$t("alertMsg.delSuccess"), "success");
      });
    },

    toDetails() {
      this.centerDialogVisible = true;
    },

    edit() {
      this.$router.push({
        name: "createManual",
        query: { k: this.manualItem.file.key, ...this.$route.query }
      });
    },

    getPageNum(val) {
      this.params.offset = (val - 1) * this.params.limit;
      this.getList();
    },

    tableHandle(obj) {
      this.manualItem = obj.data.row;
      switch (obj.type) {
        case this.$t("commonMsg.checkDetails"):
          this.toDetails();
          break;
        case this.$t("commonMsg.edit"):
          this.edit();
          break;
        case this.$t("commonMsg.del"):
          this.operationType = "manual";
          this.$store.commit("windowHandle", "delPopup");
          break;
        default:
          break;
      }
    }
  },

  mounted() {
    this.getCategory();
  }
};
</script>

<style lang="scss">
.manual {
  .manual-main {
    flex: 1;
    display: flex;
    overflow: hidden;
    .manual-main-left {
      margin: 20px 0 20px 20px;
      width: 250px;
      display: flex;
      flex-direction: column;
      .manual-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      > .el-card__body {
        flex: 1;
        display: flex;
        overflow: hidden;
      }
      .manual-menu {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        .manual-menu-submenu {
          > .el-submenu__title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .manual-menu-submenu-btn {
              display: none;
              align-items: center;
              padding-right: 10px;
            }
            &:hover {
              background: #f3f6f9;
              .manual-menu-submenu-btn {
                display: flex;
              }
            }
          }
        }
        .manual-menu-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 5px;
          padding: 10px;
          cursor: pointer;
          > p {
            flex: 1;
          }
          &:hover {
            background: #f3f6f9;
            > .manual-btn {
              display: block;
            }
          }
          .manual-btn {
            display: none;
            > i {
              margin-left: 10px;
            }
          }
        }
        .menuActive {
          background: #f3f6f9;
        }
      }
    }
  }
  .manual-btn {
    text-align: right;
    padding: 10px;
  }
  .manual-pagination {
    padding: 10px;
    text-align: right;
  }
  .manual-dialog-item {
    padding: 10px 0;
    line-height: 25px;
    > p:first-child {
      font-weight: bold;
    }
  }
  .manualHandle-dialog {
    height: 500px;
    overflow: hidden;
    .manualHandle-dialog-item {
      display: flex;
      align-items: flex-end;
      > .manualHandle-dialog-item-left {
        flex: 1;
        margin-right: 20px;
        > p {
          font-weight: bold;
        }
      }
      > .manualHandle-dialog-item-right {
        > p {
          font-weight: bold;
        }
      }
      > .manualHandle-dialog-item-btn {
        width: 80px;
        padding: 0 20px;
        > i {
          color: #fff;
          font-size: 14px;
          font-weight: bold;
          margin-left: 20px;
          border-radius: 100px;
          background: $globalLessBGColor;
          padding: 2px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
